import { defineStore } from 'pinia';

export const useSiteStore = defineStore({
  id: 'site',
  state: () => ({
    loading: false,
    message: 'Hello world',
    istouch: window.USER_IS_TOUCHING, //for testing touch devices
    issafarimobile: window.USER_IS_ON_MOBILE_SAFARI, //detect mobile safari
    logging: true,
    summarykey: null,
    promokey: null,
    messages: [],
  }),
  getters: {
    isLoading: (state) => state.loading,
    getMessages: (state) => state.messages,
  },
  actions: {
    setLoading(value) {
      this.loading = value;
    },
    addMessage(message) {
      this.messages.push(message);
      setTimeout(() => {
        this.messages = this.messages.filter((m) => m !== message);
      }, 3000);
    },
  },
});
